import { render, staticRenderFns } from "./DialogShowPackagesRate.vue?vue&type=template&id=6d2afea0&scoped=true"
import script from "./DialogShowPackagesRate.vue?vue&type=script&lang=js"
export * from "./DialogShowPackagesRate.vue?vue&type=script&lang=js"
import style0 from "./DialogShowPackagesRate.vue?vue&type=style&index=0&id=6d2afea0&lang=css"
import style1 from "./DialogShowPackagesRate.vue?vue&type=style&index=1&id=6d2afea0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2afea0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2afea0')) {
      api.createRecord('6d2afea0', component.options)
    } else {
      api.reload('6d2afea0', component.options)
    }
    module.hot.accept("./DialogShowPackagesRate.vue?vue&type=template&id=6d2afea0&scoped=true", function () {
      api.rerender('6d2afea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/dialogs/dialog_show_packages_rate/DialogShowPackagesRate.vue"
export default component.exports